import { testimonials } from "@/data/testimonials";

const Testimonials = () => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section
      data-testid="section-testimonials"
      className="bg-white border-y border-[#E7E7E2]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="overline">— Kind notes</div>
        <h2 className="mt-5 font-sora text-[32px] sm:text-[40px] lg:text-[48px] font-bold text-[#111111] tracking-tight leading-[1.05]">
          From people using Vaymilo.
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E7E7E2] border border-[#E7E7E2] rounded-2xl overflow-hidden">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="bg-white p-7 md:p-8 flex flex-col"
            >
              <blockquote className="font-sora text-[19px] md:text-[21px] leading-[1.45] text-[#111111] font-medium">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-auto pt-6 font-manrope text-[14px] text-[#111111]/65">
                <div className="text-[#111111] font-medium">{t.name}</div>
                {t.role && <div className="text-[13px]">{t.role}</div>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
